import React from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const PermissionDenied = (props) => {
  const navigate = useNavigate()

  return (
    <div className={"permission_denied"}>
      <h1>Permission Denied</h1>
      <h5>You do not have permission to access this page,</h5>
      <h5>please refer to your system administrator</h5>
      <div className={"permission_button"}>
        <Button className={"tablestrip_list_anchor"} onClick={() => navigate(-1)}>
          GO BACK
        </Button>
        <Link to="/cms" className={"tablestrip_list_anchor"}>
          GO TO HOME PAGE
        </Link>
      </div>
    </div>
  );
};

export default PermissionDenied;
